import { requestApi } from "./axiosHelper"

const rootUrl = process.env.NODE_ENV
  ? process.env.REACT_APP_API_ROOT_URL
  : "http://localhost:8000/api/v1"

const enrolEP = rootUrl + "/enrol"

const enrolAPI = {
  createNewEnrol: async (obj) => {
    const axiosData = {
      url: enrolEP,
      method: "post",
      data: obj,
    }
    const data = await requestApi(axiosData, true)
    return data
  },

  addInstallment: async (obj) => {
    try {
      const axiosData = {
        url: `${enrolEP}/installment`,
        method: "post",
        data: obj,
      }
      const data = await requestApi(axiosData, true)
      return data
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message }
    }
  },

  updateInstallment: async (obj) => {
    try {
      const axiosData = {
        url: `${enrolEP}/installment`,
        method: "patch",
        data: obj,
      }
      const data = await requestApi(axiosData, true)
      return data
    } catch (error) {
      return (
        error?.response?.data || { status: "error", message: error.message }
      )
    }
  },

  deleteInstallment: async (obj) => {
    try {
      const axiosData = {
        url: `${enrolEP}/installment`,
        method: "delete",
        data: obj,
      }
      return requestApi(axiosData, true)
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message }
    }
  },

  fetchEnrols: async (_id) => {
    try {
      const axiosData = {
        url: _id ? `${enrolEP}/${_id}` : enrolEP,
        method: "get",
      }
      const data = await requestApi(axiosData, true)
      return data
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message }
    }
  },
  fetchLocationEnrols: async (params) => {
    try {
      const axiosData = {
        url: `${enrolEP}/location/branch?${params}`,
        method: "get",
      }
      const data = await requestApi(axiosData, true)
      return data
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message }
    }
  },

  updateEnrol: async (_id, obj) => {
    const axiosData = {
      url: `${enrolEP}/${_id}`,
      method: "put",
      data: obj,
    }
    try {
      const data = await requestApi(axiosData, true)
      return data
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message }
    }
  },

  addEnrolmentNote: async (obj) => {
    const axiosData = {
      url: enrolEP,
      method: "put",
      data: obj,
    }
    const data = await requestApi(axiosData, true)
    return data
  },

  addEnrolmentCancelNote: async (obj) => {
    const { _id } = obj
    const axiosData = {
      url: `${enrolEP}/${_id}`,
      method: "put",
      data: obj,
    }
    const data = await requestApi(axiosData, true)
    return data
  },

  deleteAEnrol: async (_id) => {
    try {
      const axiosData = {
        url: `${enrolEP}/${_id}`,
        method: "delete",
      }
      const data = await requestApi(axiosData, true)

      return data
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message }
    }
  },
}

export default enrolAPI
